module.exports = __webpack_public_path__ + "img/anhuimj.97213df4.png";